import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import ProtectedRoute from './ProtectedRoute';
import { resolvePostAuthPath } from '@/utils/oauth';
import { isKnownRole } from '@/utils/sessionUser';

const LoadingScreen = () => (
  <div className="min-h-screen flex items-center justify-center bg-[#0a0f1a] text-white">
    <p className="animate-pulse text-sm text-white/60">Carregando…</p>
  </div>
);

const RoleRoute = ({ children, role: requiredRole }) => {
  const { user, loading } = useAuth();
  const userRole = user?.role;

  return (
    <ProtectedRoute>
      {loading ? <LoadingScreen /> : null}
      {!loading && user && isKnownRole(userRole) && userRole !== requiredRole ? (
        <Navigate to={resolvePostAuthPath(user)} replace />
      ) : null}
      {!loading && user && isKnownRole(userRole) && userRole === requiredRole ? children : null}
      {!loading && user && !isKnownRole(userRole) ? (
        <Navigate to="/login" replace />
      ) : null}
    </ProtectedRoute>
  );
};

export default RoleRoute;
